module.exports = __webpack_public_path__ + "img/logo-fff.dc47c297.png";